import { createReducer } from '@reduxjs/toolkit';

import { resetWarehouseFilter, setWarehouseFilter } from '../../../actions/coilovers/warehouse/warehouseFilter';
import DEFAULT_PAGINATION_SIZE from '../../../constants/general';

const initialState = {
  page: 1,
  size: DEFAULT_PAGINATION_SIZE,
  order: undefined,
  needToOrder: undefined,
  needPartsToOrder: undefined,
  brands: undefined,
  query: undefined,
  isOverstock: undefined
};

const warehouseFilterReducer = createReducer(initialState, {
  [setWarehouseFilter]: (state, { payload }) => ({
    ...state,
    ...payload
  }),
  [resetWarehouseFilter]: () => initialState
});

export default warehouseFilterReducer;
